<template>
	<v-container>
		<v-card>
			<v-container>
				<v-layout align-center justify-space-between wrap class="mb-2">
					<h2 class="title">Glückwunsch</h2>
					<navigation />
				</v-layout>
				<calculator />
			</v-container>
		</v-card>
	</v-container>
</template>

<script>
import Calculator from './Calculator.vue';
import Navigation from './Navigation.vue';

export default {
	components: {
		Calculator,
		Navigation,
	},
	mounted() {
		let externalScript = document.createElement('script');
		externalScript.setAttribute('src', '/tracking.js');
		document.head.appendChild(externalScript);
	},
};
</script>
